<template>
  <q-list
    :dense="dense"
  >
    <MetadataItem
      v-for="(metadata, key) in list"
      :key="key"
      :metadata="metadata"
      :name-spacing="nameSpacing"
      :large="large"
      :without-icon="withoutIcon"
    />
    <slot v-if="list.length < 1" name="no-results" />
  </q-list>
</template>

<script>
import { DEFAULT_ICON } from './../metadataMixin'
import MetadataItem from './MetadataItem'

/**
 * View a list of metadata in a read-only view
 *
 * SLOTS:
 * no-results: Display something if no results are available
 */

export default {
  components: {
    MetadataItem
  },
  props: {
    // List of metadata to display
    list: {
      type: Array,
      required: true
    },
    // DetailItem namespacing
    nameSpacing: {
      type: Number
    },
    // DetailItem large view
    large: {
      type: Boolean
    },
    // Hide icons for metadata
    withoutIcon: {
      type: Boolean
    },
    // Display list in dense mode
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDefault () {
      return !!this.metadata.metadata_default
    },
    isCustom () {
      return !this.hasDefault
    },
    metadataDefault () {
      return this.metadata.metadata_default
    },
    iconToDisplay () {
      const icon = this.hasDefault ? this.metadataDefault.icon : null
      return icon || DEFAULT_ICON
    }
  }
}
</script>
